"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function ColumnGroup(props) {
  return null;
}

exports.default = ColumnGroup;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/ColumnGroup.js
// module id = 705
// module chunks = 0